// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__BIkXa","placeHolderShimmer":"Report_placeHolderShimmer__65Wgc"};